import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';

const Footer = () => {

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to={ROUTES.PRIVACY}>Privacy Policy</Link>
          <Link to={ROUTES.TERMS}>Terms of Service</Link>
          <Link to={ROUTES.DISCLAIMER}>Disclaimer</Link>
        </div>
        <div className="footer-disclaimer">
          <p>All gameplay on Vinor is for entertainment purposes only. No gambling, no prizes, no real
            money involved, and no risk. Just fun, just spins, a clean break from the everyday. Players must be
            <strong> 18 or older</strong> to join. If playing ever stops feeling fun, we encourage you to take a
            break. By playing, you confirm that you are old enough and that you respect the rules. We reserve
            the right to restrict access for anyone who does not follow fair play.</p>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">&copy; 2026 <strong>Vinor</strong>. All rights reserved.</p>
          <div className="footer-badges">
            <span className="age-badge-footer">18+</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;